<template>
  <transition name="slide">
    <div
      class="slidein"
      v-if="drawer"
      style="width:100% !important; height: fit-content !important; margin-top: 110%; border-radius: 20px 20px 0 0;
      background: white; box-shadow: 0px 4px 20px rgba(114, 114, 114, 0.1);"
    >
      <div style="align-items: center;width:100%;height:auto;">
        <v-row>
          <v-col cols="12" style="font-size: 16px;">
              <b>นโยบายและเงื่อนไขในการจองคิวJoyRide แบบจองล่วงหน้าน้อยกว่า 24
              ชั่วโมงก่อนวันรับบริการ</b>
              <br>จะมีค่าธรรมเนียมการจองการจองละ 300 บาท
              (รวมภาษีมูลค่าเพิ่มแล้ว) การจองที่สมบูรณ์แล้ว หมายถึง
              ท่านได้ชำระค่าบริการ และค่าธรรมเนียมดังกล่าวแก่ทางบริษัทฯ
              เรียบร้อยแล้ว ไม่สามารถคืนเงินหรือยกเลิกได้
              โดยผู้ใช้บริการยอมรับในนโยบายและเงื่อนไขดังกล่าวแล้ว <br><br> A processing
              fee of THB 300 (including VAT) will be applicable for advanced
              bookings made less than 24 hours before the service. A complete
              booking is considered finalized only after the service recipient
              has successfully paid both the service fee and the processing fee.
              Please note that cancellations and refunds are not permitted for
              such bookings.
            <div style="display:flex;justify-content: center;" class="ma-3">
              <v-btn
                class="text-none"
                color="#EAE9EC"
                min-width="92"
                variant="outlined"
                elevation="0"
                rounded
                @click="updatePrice('False')"
              >
                ไม่ยอมรับ
              </v-btn>
              &emsp;
              <v-btn
                class="text-none font-weight-bold"
                :color="DarkModeButton"
                min-width="92"
                variant="outlined"
                rounded
                dark
                @click="updatePrice('True')"
              >
                ยอมรับ
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: [
    'toggleParent',
    'drawerParent',
    'languageSelectParent',
    'dataMenuParent',
    'priceMenuParent',
    'updatePriceMenuParent',
    'DarkModeButtonParent'
  ],
  data () {
    return {
      drawer: this.drawerParent,
      languageSelect: this.languageSelectParent,
      dataMenu: this.dataMenuParent,
      priceMenu: this.priceMenuParent,
      detailsNameSub: false,
      detailsData: '',
      DarkModeButton: this.DarkModeButtonParent
    }
  },
  async mounted () {},
  methods: {
    toggleJoyRide () {
      this.toggleParent()
    },
    updatePrice (items) {
      console.log('items >>>><<<<', items)
      this.$emit('updatePriceMenuParent', items)
      this.toggleParent()
    }
  },
  watch: {
    languageSelect () {
      this.languageSelect = this.languageSelectParent
    },
    drawerParent () {
      this.drawer = this.drawerParent
    },
    dataMenuParent () {
      this.dataMenu = this.dataMenuParent
    },
    DarkModeButtonParent () {
      this.DarkModeButton = this.DarkModeButtonParent
    }
  }
}
</script>
<style scoped>

.slide-enter,
.slide-leave-active {
  top: 100%;
}
.close-btn {
  border: none;
  font-weight: bold;
  font-size: 2em;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/sideMenuJoyRideFast.vue